export default {"src":"/_next/static/media/winningsSecured.93dfb660.svg","height":19,"width":206,"blurWidth":0,"blurHeight":0};